import React, { Component } from 'react';
import { Translation } from 'react-i18next';

import CognitoFormForm from '../containers/CognitoFormFormContainer';
import DocumentHead from '../../../elements/components/DocumentHead';
import Logger from '../../../../../lib/Logger';

class CognitoFormEditScreen extends Component {
  scrollToTop = () => {
    Logger.log('debug', `CognitoFormEditScreen.scrollToTop()`);
    if (typeof window !== 'undefined') {
      setTimeout(() => window.scrollTo(0, 0), 100);
    }
  };

  render() {
    return (
      <Translation>
        {(t) => (
          <div>
            <DocumentHead title={t('cognito_form_route_edit')} />
            <CognitoFormForm id={this.props.match.params.id} />
          </div>
        )}
      </Translation>
    );
  }

  /* LIFECYCLE EVENTS */

  componentDidMount() {
    this.scrollToTop();
  }
}

export default CognitoFormEditScreen;

Logger.log('silly', `CognitoFormEditScreen loaded.`);
